import React, {useCallback} from 'react';

import {Carousel as ResponsiveCarousel} from 'react-responsive-carousel';

const Carousel = ({ carouselProps, className, children, hasCaption }) => {

    const renderArrowPrev = useCallback((clickHandler, hasPrev, label) => {
        const onClick = (e) => {
            e.preventDefault(); e.stopPropagation();
            clickHandler();
        }
        return carouselProps.showArrows === true && (
            <button type="button" aria-label={label} className="control-arrow control-prev" onClick={onClick} />
        )
    });

    const renderArrowNext = useCallback((clickHandler, hasNext, label) => {
        const onClick = (e) => {
            e.preventDefault(); e.stopPropagation();
            clickHandler();
        }
        return carouselProps.showArrows === true && (
            <button type="button" aria-label={label} className="control-arrow control-next" onClick={onClick} />
        )
    });

    const renderIndicator = (
        onClickHandler, isSelected, index, label
    ) => {
        const onClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClickHandler();
        }
        return (
            <li
                className={"dot" + (isSelected ? " selected" : "")}
                onClick={onClick}
                onKeyDown={onClick}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                aria-label={`${label} ${index + 1}`}
            />
        );
    };

    return <ResponsiveCarousel {...carouselProps}
        className={className}
        showIndicators={children && children.length > 1}
        renderArrowNext={renderArrowNext}
        renderArrowPrev={renderArrowPrev}
        renderIndicator={renderIndicator}
    >
        {children}
    </ResponsiveCarousel>

}

export default Carousel;
